export default {
  name: 'modalFund',
  props: [],
  components: {},
  data() {
    return {}
  },
  filters: {},
  methods: {
    accept() {
      this.$emit('accept')
      $('#modalFund').modal('close')
    },
  },
  computed: {},
  beforeCreate: function () {},
  created() {},
  mounted() {
  },
}


// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ModalFund/ModalFund.component.js